import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCrypto } from '../contexts/CryptoContext';
import UnlockVaultModal from './UnlockVaultModal';

// Détruit la MK en mémoire quand l'utilisateur se déconnecte (DEC-016).
export const useLockOnLogout = () => {
  const { isAuthenticated } = useAuth();
  const { lockVault } = useCrypto();

  useEffect(() => {
    if (!isAuthenticated) lockVault();
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps
};

// Bloque la navigation vers les pages protégées tant que la MK n'est pas en mémoire.
// Affiché uniquement si l'onboarding est terminé — pas bloquant pendant l'onboarding.
export const MKGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { isUnlocked } = useCrypto();

  if (isAuthenticated && user?.onboarding_completed && !isUnlocked) {
    return <UnlockVaultModal />;
  }
  return children;
};
